import React from 'react';
import {useTranslation} from "react-i18next";

const Maintenance = function ({activePage}) {
    const {t} = useTranslation();
    const pageMapping = {
        'Cash': t(`tabs.Cash`),
        'Tournament': t(`tabs.Tournament`),
        'History': t(`mobile_side_menu.history`),
    }
    const handleMaintenanceMsg = () => {
        if (activePage === 'Game') {
            return t("maintenance.msg")
        }
        return t("maintenance.section", { section: pageMapping?.[activePage] })
    }
    return (
        <div className="maintenance">
            <img
                src="./images/loader/loader.gif"
                alt={`loader`}
                loading={"lazy"}
            />
            <p className="maintenance-text">
                {handleMaintenanceMsg()}
            </p>
        </div>
    )
}

export default Maintenance